import React, { useState, useEffect, useId, useRef } from 'react';
import { supabase } from '../supabaseClient';

const VERSAO_TERMOS = '1.0';

const TEXTO_TERMOS = `TERMOS DE USO E POLÍTICA DE RESPONSABILIDADE
ClimoraX – Clima para o Agro
Versão 1.0 – Junho de 2026

1. ACEITAÇÃO DOS TERMOS
Ao utilizar o aplicativo ClimoraX ("Aplicativo"), você ("Usuário") declara ter lido, compreendido e concordado integralmente com estes Termos de Uso. Caso não concorde, não utilize o Aplicativo.

2. NATUREZA INFORMATIVA DOS DADOS
2.1. As informações fornecidas pelo ClimoraX — incluindo previsões climáticas, dados meteorológicos, balanço hídrico, estimativas de irrigação, zoneamento agrícola (ZARC), fenologia de culturas e recomendações agronômicas — têm caráter EXCLUSIVAMENTE INFORMATIVO E ORIENTATIVO.

2.2. Os dados apresentados são obtidos de fontes externas (estações meteorológicas, modelos climáticos, órgãos públicos e sensores de terceiros) e podem conter imprecisões, atrasos ou indisponibilidades.

2.3. As informações do ClimoraX NÃO substituem a orientação de profissionais habilitados (engenheiros agrônomos, técnicos agrícolas, meteorologistas), nem devem ser usadas como único critério para decisões comerciais, financeiras ou técnicas.

3. LIMITAÇÃO DE RESPONSABILIDADE
3.1. O ClimoraX e seus desenvolvedores, sócios, colaboradores e fornecedores NÃO se responsabilizam por qualquer dano direto, indireto, incidental, especial ou consequente resultante de:
   a) Decisões agronômicas, de plantio, colheita, irrigação ou manejo tomadas com base nos dados do Aplicativo;
   b) Perdas de produção, prejuízos econômicos ou danos à propriedade decorrentes do uso das informações;
   c) Falhas, interrupções ou imprecisões nos dados climáticos ou nas estimativas fornecidas;
   d) Eventos climáticos extremos ou imprevistos não contemplados pelas previsões.

3.2. O Usuário assume integralmente a responsabilidade pelas decisões tomadas com base nas informações do Aplicativo.

4. ISENÇÃO EM DADOS DE TERCEIROS
Os dados de ZARC são fornecidos pelo Ministério da Agricultura, Pecuária e Abastecimento (MAPA) e seguem as tabelas oficiais vigentes. O ClimoraX não garante a atualização em tempo real dessas tabelas e recomenda consulta às fontes oficiais antes de decisões críticas.

5. SENSORES E DISPOSITIVOS
5.1. Dados provenientes de sensores conectados são de responsabilidade do Usuário quanto à calibração, manutenção e precisão dos equipamentos.
5.2. O ClimoraX não garante a exatidão de leituras de sensores de terceiros integrados ao Aplicativo.

6. PROPRIEDADE INTELECTUAL
Todos os conteúdos, marcas, logotipos, algoritmos e interfaces do ClimoraX são de propriedade exclusiva de seus desenvolvedores. É proibida a reprodução, distribuição ou uso comercial sem autorização expressa.

7. PRIVACIDADE E DADOS PESSOAIS
O tratamento de dados pessoais segue nossa Política de Privacidade, elaborada em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018). Os dados cadastrais são utilizados exclusivamente para operação do Aplicativo e não são vendidos a terceiros.

8. DISPONIBILIDADE DO SERVIÇO
O ClimoraX é fornecido "no estado em que se encontra". Não garantimos disponibilidade ininterrupta do serviço e nos reservamos o direito de realizar manutenções, atualizações ou descontinuar funcionalidades sem aviso prévio.

9. ALTERAÇÕES NOS TERMOS
Estes Termos poderão ser atualizados a qualquer momento. Quando houver alterações relevantes, o Usuário será notificado e precisará aceitar a nova versão para continuar utilizando o Aplicativo.

10. FORO E LEGISLAÇÃO APLICÁVEL
Estes Termos são regidos pela legislação brasileira. Fica eleito o foro da comarca de Belo Horizonte, Estado de Minas Gerais, com exclusão de qualquer outro, por mais privilegiado que seja, para dirimir quaisquer controvérsias decorrentes deste instrumento.

Dúvidas ou solicitações: climorax.app@gmail.com`;

export default function TermosDeUso({ userId, onAceito, somenteVisualizacao = false }) {
  const [aceitou, setAceitou] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [leuTudo, setLeuTudo] = useState(false);
  const [erro, setErro] = useState('');
  const textoRef = useRef(null);
  const tituloId = useId();
  const descricaoId = useId();

  // Detecta quando usuário rolou até o final do texto
  useEffect(() => {
    const el = textoRef.current;
    if (!el) return;
    const handleScroll = () => {
      const chegouFim = el.scrollTop + el.clientHeight >= el.scrollHeight - 30;
      if (chegouFim) setLeuTudo(true);
    };
    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAceitar = async () => {
    if (somenteVisualizacao) { onAceito(); return; }
    if (!aceitou || salvando) return;
    setSalvando(true);
    setErro('');
    try {
      const { error } = await supabase.from('aceite_termos').upsert(
        {
          user_id: userId,
          versao_termos: VERSAO_TERMOS,
          aceito_em: new Date().toISOString(),
          user_agent: navigator.userAgent,
        },
        { onConflict: 'user_id,versao_termos' }
      );
      if (error) throw error;
      onAceito();
    } catch (e) {
      console.error('Erro ao salvar aceite:', e);
      setErro('Não foi possível registrar sua confirmação. Verifique a conexão e tente novamente.');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby={tituloId}
      aria-describedby={descricaoId}
      style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.7)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
      boxSizing: 'border-box',
      }}
    >
      <div style={{
        background: '#fff',
        borderRadius: 20,
        maxWidth: 540,
        width: '100%',
        maxHeight: '92vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 8px 40px rgba(0,0,0,0.35)',
        overflow: 'hidden',
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #1565c0 0%, #2e9e6e 100%)',
          padding: '18px 20px',
          flexShrink: 0,
        }}>
          <div id={tituloId} style={{ fontSize: 22, fontWeight: 800, color: '#fff' }}>📋 Termos de Uso</div>
          <div id={descricaoId} style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', marginTop: 2 }}>
            Leia com atenção antes de continuar
          </div>
        </div>

        {/* Texto dos termos */}
        <div
          ref={textoRef}
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: '16px 20px',
            fontSize: 12.5,
            lineHeight: 1.65,
            color: '#333',
            whiteSpace: 'pre-wrap',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          {TEXTO_TERMOS}
          {/* Marcador de fim para garantir que botão aparece */}
          <div style={{ height: 8 }} />
        </div>

        {/* Dica de rolagem */}
        {!leuTudo && (
          <div style={{
            textAlign: 'center',
            fontSize: 12,
            color: '#888',
            padding: '6px 0 2px',
            background: '#fafafa',
            borderTop: '1px solid #eee',
            flexShrink: 0,
          }}>
            ↕ Role para ler todo o conteúdo
          </div>
        )}

        {/* Rodapé com checkbox e botão */}
        <div style={{
          padding: '14px 20px 18px',
          borderTop: '1px solid #eee',
          background: '#fafafa',
          flexShrink: 0,
        }}>
          {!somenteVisualizacao && (
            <label style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 10,
              cursor: 'pointer',
              marginBottom: 14,
            }}>
              <input
                type="checkbox"
                checked={aceitou}
                onChange={e => {
                  setAceitou(e.target.checked);
                  setErro('');
                }}
                style={{ marginTop: 2, width: 18, height: 18, accentColor: '#1565c0', flexShrink: 0 }}
              />
              <span style={{ fontSize: 13, color: '#444', lineHeight: 1.5 }}>
                Li e concordo com os Termos de Uso e compreendo que as informações do ClimoraX são de caráter informativo e não substituem orientação profissional.
              </span>
            </label>
          )}

          {erro && (
            <p role="alert" style={{ margin: '0 0 12px', color: '#a12b26', fontSize: 13, fontWeight: 600 }}>
              {erro}
            </p>
          )}

          <button
            onClick={handleAceitar}
            disabled={!somenteVisualizacao && (!aceitou || salvando)}
            style={{
              width: '100%',
              padding: '13px 0',
              borderRadius: 12,
              border: 'none',
              background: (somenteVisualizacao || aceitou)
                ? 'linear-gradient(135deg, #1565c0 0%, #2e9e6e 100%)'
                : '#ccc',
              color: '#fff',
              fontSize: 15,
              fontWeight: 700,
              cursor: (somenteVisualizacao || aceitou) ? 'pointer' : 'not-allowed',
              transition: 'background 0.2s',
            }}
          >
            {somenteVisualizacao ? 'Fechar' : salvando ? 'Salvando...' : 'Aceitar e continuar'}
          </button>
        </div>
      </div>
    </div>
  );
}

// Versão exportada para checagem
export { VERSAO_TERMOS };
